import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function promotionListHasErrored(bool) {
  return {
    type: 'PROMOTION_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function promotionListIsLoading(bool) {
  return {
    type: 'PROMOTION_LIST_IS_LOADING',
    isLoading: bool,
  };
}
export function promotionListFetchDataSuccess(promotionList) {
  return {
    type: 'PROMOTION_LIST_FETCH_DATA_SUCCESS',
    promotionList,
  };
}

export function promotionDetailsHasErrored(bool) {
  return {
    type: 'PROMOTION_DETAILS_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function promotionDetailsIsLoading(bool) {
  return {
    type: 'PROMOTION_DETAILS_IS_LOADING',
    isLoading: bool,
  };
}
export function promotionDetailsFetchDataSuccess(promotion) {
  return {
    type: 'PROMOTION_DETAILS_FETCH_DATA_SUCCESS',
    promotion,
  };
}

export function newPromotionSaveSuccess(bool, campaign) {
  return {
    type: 'NEW_PROMOTION_SAVE_SUCCESS',
    isSavedSuccess: bool,
    campaign: campaign,
  };
}

export function newPromotionSaveErrored(bool, message) {
  return {
    type: 'NEW_PROMOTION_SAVE_ERRORED',
    isSaveErrored: bool,
    message: message,
  };
}

export function newPromotionIsSaving(bool) {
  return {
    type: 'NEW_PROMOTION_IS_SAVING',
    isSaving: bool,
  };
}

export function redirectToPromotionListPage(bool) {
  return {
    type: 'REDIRECT_TO_PROMOTION_LIST',
    doRedirectToPromotionListPage: bool,
  };
}

export function redirectToOfferListPage(bool) {
  return {
    type: 'REDIRECT_TO_OFFER_LIST',
    doRedirectToOfferListPage: bool,
  };
}

function buildQueryString(source, startDate, endDate, searchCriteria, status) {
  let queryString = '';
  if (source) queryString += '&source=' + source;
  queryString += '&startDate=' + startDate;
  queryString += '&endDate=' + endDate;
  if (searchCriteria) queryString += '&searchCriteria=' + searchCriteria;
  if (status) queryString += '&status=' + status;
  return queryString ? '?' + queryString.substring(1) : '';
}

export function promotionListFetchData(
  source,
  startDate,
  endDate,
  searchCriteria,
  status,
) {
  const queryString = buildQueryString(
    source,
    startDate,
    endDate,
    searchCriteria,
    status,
  );
  const url = queryString
    ? apiEndPoints.PROMOTION_LIST + queryString
    : apiEndPoints.PROMOTION_LIST;
  return async (dispatch) => {
    dispatch(promotionListIsLoading(true));
    try {
      const response = await adalApiFetch(fetch, url, {});
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      dispatch(promotionListIsLoading(false));
      const items = await response.json();
      dispatch(promotionListFetchDataSuccess(items));
    } catch (error) {
      dispatch(promotionListHasErrored(true));
      dispatch(promotionListIsLoading(false));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}

export function getPromotionData(id) {
  const url = apiEndPoints.PROMOTION_DETAILS.replace('promotionId', id);
  return async (dispatch) => {
    dispatch(redirectToPromotionListPage(false));
    dispatch(promotionDetailsIsLoading(true));
    try {
      const response = await adalApiFetch(fetch, url, {});
      dispatch(promotionDetailsIsLoading(false));
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const item = await response.json();
      dispatch(promotionDetailsFetchDataSuccess(item));
    } catch (error) {
      dispatch(promotionDetailsHasErrored(true));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}

export function addNewPromotionData(newPromotion) {
  const url = apiEndPoints.PROMOTION_ADD;
  return async (dispatch) => {
    dispatch(newPromotionIsSaving(true));
    try {
      const response = await adalApiFetch(fetch, url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(newPromotion),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      dispatch(newPromotionIsSaving(false));
      if (response.ok) {
        const campaign = await response.json();
        dispatch(newPromotionSaveSuccess(true, campaign));
        dispatch(redirectToPromotionListPage(true));
      } else {
        switch (response.status) {
          case 422: {
            const error = await response.json();
            const items = Object.values(error);
            const message = items.join('; ');
            dispatch(newPromotionSaveErrored(true, message));
            break;
          }
          default: {
            const error = await response.json();
            dispatch(newPromotionSaveErrored(true, error.message));
            break;
          }
        }
      }
    } catch (error) {
      dispatch(newPromotionIsSaving(false));
      dispatch(newPromotionSaveErrored(true, error.message || 'Unknown error'));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}
